import React, { useState, useContext } from "react";
import { RoleCtx } from "../../../../lib/context";
import { useHistory } from "react-router-dom";
import "../../../../ui-styles/list/profileWrapList.css";
import "../../../../ui-styles/profile/HzntlProfile.css";

import Button from "../../../../lib/ui/buttons/Button";
import TxtBtn from "../../../../lib/ui/buttons/TxtButton";
import { toast } from "react-toastify";

import { LangCtx } from "../../../../lib/context";
// import DoctorProfileSlide from "./DoctorProfileSlide";
import { addrLangObj } from "../../../../locale/address";
import { getExperience } from "../../../../lib/functions";
// import { checkPrevPostPaidAppt } from "../../../../actions/appointment";
import Loader from "../../../../lib/ui/loader/Loader";
// import { getDegree, getDepartmentList, getSpecialization } from "../../../../actions/configuration";
// import currencySymbols from "../../../../locale/currencyCodes.json";
// import { useSelector } from "react-redux";
import Rating from '@material-ui/lab/Rating';


const DoctorsListItem = (props) => {
    const { l, currencyCode } = useContext(LangCtx);
    const al = addrLangObj[l.locale];
    const { role } = useContext(RoleCtx);
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const { data, patientId } = props;
    // const rates = useSelector((state) => state?.inclinic?.rates);

    const location = localStorage.getItem('country');

    function getPrevPostPaidAppt() {
        try{
        // let query = "";

        // if (role === "C") {
        //     query = `?patientId=${patientId}`;
        // }
        setLoading(true);
        // checkPrevPostPaidAppt(query)
        //     .then((res) => {
        //         if (res.status) {
                    if (role === "C") {
                        history.push(`/clinic/book-appointment/${data.userId}/${patientId}`, {
                            date: props.date,
                            fee: (data?.newconsultationFee && data?.newconsultationFee[0]?.country.includes(location))? data.newconsultationFee.amount:data.consultationFee
                        });
                    } else {
                        history.push(`/book-appointment/${data.userId}`, { date: props.date, fee: (data?.newconsultationFee && data?.newconsultationFee[0]?.country.includes(location))? data.newconsultationFee.amount:data.consultationFee });
                    }
            //     } else {
            //         console.log("Error in response");
            //     }
            //     setLoading(false);
            // })
              setLoading(false);

            }catch(err) {
                toast.error(err?.response?.data?.error || "An error occurred", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setLoading(false);
                if (role === "C") {
                    history.push({
                        pathname: "/appointments",
                        state: {
                            active: "PA",
                        },
                    });
                } else if (role === "P") {
                    history.push({
                        pathname: "/patient-dashboard",
                        state: {
                            active: "PA",
                        },
                    });
                }
            };
    }

    const renderConsultationFee = () => {
        if (!data?.paymentType || data?.paymentType === "free") return null; 
        const matchingFee = data?.newconsultationFee?.find(
            (fee) => String(fee.currency).toUpperCase() === String(currencyCode).toUpperCase()
        );

        if (matchingFee) {
            return (
                <span className="profleSDrkTxt">
                    <strong>
                        {`${matchingFee.currency} ${matchingFee.amount}`}
                    </strong>{" "}
                    {l.consult_fee}
                </span>
            );
        } else if (data?.currency) {
            return (
                <span className="profleSDrkTxt">
                    <strong>
                    {`${data.currency} ${
                        data.consultationFee
                            ? Number(data.consultationFee)
                            : 0
                    }`}
                    </strong>{" "}
                    {l.consult_fee}
                </span>
            );
        } else {
            return null
        }
    };
    
    

    return (
        <div className="proCardBox">
            {loading && <Loader />}
            <div className="proCard">
                <div className="proCardBdy">
                    <div className={`proCardAvtr ${data.available ? "online" : "offline"}`}>
                        <img
                            src={data.profileImage?.url ? data.profileImage.url : "/images/icons/doctor-default.png"}
                            alt="avatar"
                        />
                    </div>
                    <div className="proCardInfo">
                        <span className="proInfoLTxt primaryTxtColor">{`Dr. ${data.firstName} ${data.lastName || ""}`}</span>
                        <span ><Rating name="read-only" precision={0.1}  value={data.ratings?.stars || 0} readOnly /></span>

                        <span className="profleSTxt">
                            {data.qualification || ""}
                            {data.department ? `(${data.department})` : ""}
                            {data.serviceStartDate ? `- ${getExperience(new Date(data.serviceStartDate))}` : ""}
                        </span>
                        <span className="profleSTxt">{data.speciality || ""}</span>
                        <span className="profleSDrkTxt">{data?.stateName ? al[data.stateName] : ""}</span>

                        {renderConsultationFee()}

                        <span className="profleSDrkTxt">Payment Mode : {data?.paymentType || "N/A"}</span>
                    </div>
                </div>
                <div className="proCardFtr">
                    <div className="proFrtRow proFrtAuto">
                        <TxtBtn size="sm" label={l.view_prof} onClick={() => props.handleSlideData(props.data)} />
                    </div>
                    <div className="proFrtRow">
                        <Button
                            label={l.book_apptmnt}
                            className="btn"
                            size="sm"
                            fullWidth="fullWidth"
                            type="primary"
                            onClick={getPrevPostPaidAppt}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(DoctorsListItem);


// import React, { useState, useContext, useEffect } from "react";
// import { RoleCtx } from "../../../../lib/context";
// import { useHistory } from "react-router-dom";
// import "../../../../ui-styles/list/profileWrapList.css";
// import "../../../../ui-styles/profile/HzntlProfile.css";

// import Button from "../../../../lib/ui/buttons/Button";
// import TxtBtn from "../../../../lib/ui/buttons/TxtButton";
// import { toast } from "react-toastify";

// import { LangCtx } from "../../../../lib/context";
// import DoctorProfileSlide from "./DoctorProfileSlide";
// import { addrLangObj } from "../../../../locale/address";
// import { getExperience } from "../../../../lib/functions";
// import { checkPrevPostPaidAppt } from "../../../../actions/appointment";
// import Loader from "../../../../lib/ui/loader/Loader";
// import { getDegree, getDepartmentList, getSpecialization } from "../../../../actions/configuration";
// import currencySymbols from "../../../../locale/currencyCodes.json";
// import { useSelector } from "react-redux";

// const DoctorsListItem = (props) => {
//     const { l, currencyCode } = useContext(LangCtx);
//     const al = addrLangObj[l.locale];
//     const { role } = useContext(RoleCtx);
//     const history = useHistory();
//     // const [open, setOpen] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const { data, patientId } = props;
//     const rates = useSelector((state) => state?.inclinic?.rates);
//     // console.log("rates..................:)", rates)

//     const location = localStorage.getItem('country')
//     console.log("locationnnnnn",location)

//     function getPrevPostPaidAppt() {
//         console.log("check prev payment---------", role, patientId);
//         let query = "";

//         if (role === "C") {
//             query = `?patientId=${patientId}`;
//         }
//         setLoading(true);
//         checkPrevPostPaidAppt(query)
//             .then((res) => {
//                 if (res.status) {
//                     // handleNext(token)
//                     if (role === "C") {
//                         history.push(`/clinic/book-appointment/${data.userId}/${patientId}`, {
//                             date: props.date,
//                             fee: data.consultationFee,
//                         });
//                     } else {
//                         history.push(`/book-appointment/${data.userId}`, { date: props.date, fee: data.consultationFee });
//                     }
//                     console.log("res from getPrevPostPaidAppt", res);
//                 } else {
//                     console.log("errrr---------");
//                 }
//                 setLoading(false);
//             })
//             .catch((err) => {
//                 toast.error(err?.response?.data?.error, {
//                     position: toast.POSITION.TOP_RIGHT,
//                 });
//                 setLoading(false);
//                 if (role === "C") {
//                     history.push({
//                         pathname: "/appointments",
//                         state: {
//                             active: "PA",
//                         },
//                     });
//                 } else if (role === "P") {
//                     history.push({
//                         pathname: "/patient-dashboard",
//                         state: {
//                             active: "PA",
//                         },
//                     });
//                 }
//             });
//     }

//     // const handleClick = () => {
//     //     role === 'C' ? history.push(`/clinic/book-appointment/${data.userId}/${patientId}`, { date: props.date, fee: data.consultationFee }) : history.push(`/book-appointment/${data.userId}`, { date: props.date, fee: data.consultationFee})
//     // };

//     // const handleSlide = () => {
//     //     setOpen((prevState) => !prevState);
//     // };

//     console.log("data from patient booking appointments--", data);
//     return (
//         <div className="proCardBox">
//             {loading && <Loader />}
//             <div className="proCard">
//                 <div className="proCardBdy">
//                     <div className={`proCardAvtr ${data.available ? "online" : "offline"}`}>
//                         <img
//                             src={data.profileImage && data.profileImage.url ? data.profileImage.url : "/images/icons/doctor-default.png"}
//                             alt="avatar"
//                         />
//                     </div>
//                     <div className="proCardInfo">
//                         <span className="proInfoLTxt primaryTxtColor">{`Dr. ${data.firstName} ${data.lastName ? data.lastName : ""}`}</span>
//                         <span className="profleSTxt">
//                             {data.qualification ? data.qualification : ""}
//                             {data.department ? `(${data.department})` : ""}
//                             {data.serviceStartDate ? `- ${getExperience(new Date(data.serviceStartDate))}` : ""}
//                         </span>
//                         <span className="profleSTxt"></span>
//                         <span className="profleSTxt">{data.speciality ? data.speciality : ""}</span>
//                         <span className="profleSDrkTxt">{data.stateName ? al[data.stateName] : ""}</span>

//                         {data?.paymentType && data?.paymentType !== "free" && (
//                             <>
//                                 {console.log("dataa:::",data)}
                               
                            
//                                 {data.currency && data.currency === "INR" && (
//                                     <span className="profleSDrkTxt">
//                                         {currencyCode && role === "P" ? (
//                                             <>
//                                                 <strong>
//                                                     {currencySymbols[currencyCode].symbol}{" "}
//                                                     {data.consultationFee
//                                                         ? Math.round(data.consultationFee / (rates ? rates["inr"] : 1))
//                                                         : ""}
//                                                 </strong>{" "}
//                                                 {l.consult_fee}
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <strong>&#8377;{data.consultationFee ? data.consultationFee : ""}</strong> {l.consult_fee}
//                                             </>
//                                         )}
//                                     </span>
//                                 )}

//                                 {data.currency && data.currency === "USD" && (
//                                     <span className="profleSDrkTxt">
//                                         {currencyCode && role === "P" ? (
//                                             <>
//                                                 <strong>
//                                                     {currencySymbols[currencyCode].symbol}{" "}
//                                                     {data.consultationFee
//                                                         ? Math.round(data.consultationFee / (rates ? rates["usd"] : 1))
//                                                         : ""}
//                                                 </strong>{" "}
//                                                 {l.consult_fee}
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <strong>${data.consultationFee ? data.consultationFee : ""}</strong> {l.consult_fee}
//                                             </>
//                                         )}
//                                     </span>
//                                 )}
//                                 {data.currency && data.currency === "AED" && (
//                                     <span className="profleSDrkTxt">
//                                         {currencyCode && role === "P" ? (
//                                             <>
//                                                 <strong>
//                                                     {currencySymbols[currencyCode].symbol}{" "}
//                                                     {data.consultationFee
//                                                         ? Math.round(data.consultationFee / (rates ? rates["aed"] : 1))
//                                                         : ""}
//                                                 </strong>{" "}
//                                                 {l.consult_fee}
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <strong>&#1583;.&#1573;{data.consultationFee ? data.consultationFee : ""}</strong>{" "}
//                                                 {l.consult_fee}
//                                             </>
//                                         )}
//                                     </span>
//                                 )}
//                             </>
//                         )}
//                         <span className="profleSDrkTxt">Payment Mode : {data?.paymentType && data.paymentType}</span>
//                     </div>
//                 </div>
//                 <div className="proCardFtr">
//                     <div className="proFrtRow proFrtAuto">
//                         <TxtBtn size="sm" label={l.view_prof}  onClick={() => props.handleSlideData(props.data)} />
//                     </div>
//                     <div className="proFrtRow">
//                         <Button
//                             label={l.book_apptmnt}
//                             className="btn"
//                             size="sm"
//                             fullWidth="fullWidth"
//                             type="primary"
//                             onClick={getPrevPostPaidAppt}
//                         />
//                     </div>
//                 </div>
//             </div>
//             {/* {open && <DoctorProfileSlide open={open} handleSlide={handleSlide} closeSlide={handleSlide} data={data} />} */}
//         </div>
//     );
// };
// export default React.memo(DoctorsListItem);
